/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	OrgUnitCartCalculateDiscountCreatePathOrgUnitId,
	OrgUnitCartCalculateDiscountCreateQueryOnlyPromo,
	OrgUnitCartCalculateDiscountCreateData,
	OrgUnitCartCalculateDiscountCreateStatus200,
} from "../types/OrgUnitCartCalculateDiscountCreate.ts";

function getOrgUnitCartCalculateDiscountCreateUrl(org_unit_id: OrgUnitCartCalculateDiscountCreatePathOrgUnitId) {
	const res = { method: "POST", url: `/api/org_unit/${org_unit_id}/cart/calculate-discount/` as const };

	return res;
}

/**
 * @description Представление расчета скидок.
 * @summary расчет скидки для корзины
 * {@link /api/org_unit/:org_unit_id/cart/calculate-discount/}
 */
export async function orgUnitCartCalculateDiscountCreate(
	org_unit_id: OrgUnitCartCalculateDiscountCreatePathOrgUnitId,
	data?: OrgUnitCartCalculateDiscountCreateData,
	params?: { only_promo?: OrgUnitCartCalculateDiscountCreateQueryOnlyPromo },
	config: Partial<RequestConfig<OrgUnitCartCalculateDiscountCreateData>> & { client?: Client; contentType?: "application/json" | "application/xml" } = {},
) {
	const { client: request = client, contentType = "application/json", ...requestConfig } = config;

	const requestData = data;

	const res = await request<OrgUnitCartCalculateDiscountCreateStatus200, ResponseErrorConfig<Error>, OrgUnitCartCalculateDiscountCreateData>({
		method: "POST",
		url: getOrgUnitCartCalculateDiscountCreateUrl(org_unit_id).url.toString(),
		params,
		data: requestData,
		contentType,
		...requestConfig,
	});

	return res.data;
}
